module.exports = __webpack_public_path__ + "img/prize-04.a438b5d7.jpg";